import React from 'react'
import { Tooltip, Tag } from 'hljd'
import store from '../EditSchedule/store'
import myStore from '../store'
import moment from 'moment'

export default [
  {
    title: '宴会厅',
    dataIndex: 'entity_id',
    key: 'entity_id',
    render: entity_id => {
      const { hotelHalls } = myStore
      const span = hotelHalls.map((item, key) => {
        if (item.id == entity_id) {
          return <span key={key}>{item.name}</span>
        }
        return null
      })
      return span
    }
  },
  {
    title: '婚宴日期',
    dataIndex: 'date',
    key: 'date',
    render: text => {
      return moment(text).format('YYYY-MM-DD')
    }
  },
  {
    title: '市别',
    dataIndex: 'time_str',
    key: 'time_str',
    render: time_str => {
      if (time_str == ',1,') {
        return <span>午市</span>
      } else if (time_str == ',2,') {
        return <span>晚市</span>
      } else if (time_str == ',1,2,' || time_str == ',2,1,') {
        return <span>午市●晚市</span>
      }
    }
  },
  {
    title: '客户/电话',
    dataIndex: 'phone',
    key: 'phone',
    render: (phone, { user_name, order_no }) => {
      const scheduleFromYunXi = Boolean(order_no)
      if (phone) {
        return (
          <div>
            <span style={{ display: 'block' }}>{user_name}</span>
            <span style={{ display: 'block' }}>{phone}</span>
            {scheduleFromYunXi && (
              <Tag color="default" style={{ marginLeft: '5px' }}>
                体验店订单
              </Tag>
            )}
          </div>
        )
      }
    }
  },
  {
    title: '操作',
    dataIndex: 'action',
    key: 'action',
    render: (
      action,
      { order_no, id, entity_id, date, phone, user_name, time_str }
    ) => {
      const scheduleFromYunXi = Boolean(order_no)
      return (
        <Tooltip
          placement="bottomLeft"
          title={
            scheduleFromYunXi
              ? `来自体验店订单（订单编号：${order_no}）的档期暂不允许修改`
              : null
          }
        >
          <span
            onClickCapture={e => {
              if (scheduleFromYunXi) {
                e.preventDefault()
                e.stopPropagation()
              }
            }}
          >
            <a
              href="javascript:;"
              style={{
                color: scheduleFromYunXi ? 'gray' : '508cee',
                marginRight: 10
              }}
              onClick={store.updateSchedule(
                id,
                entity_id,
                date,
                phone,
                user_name,
                time_str
              )}
            >
              编辑
            </a>
            <a
              href="javascript:;"
              style={{ color: scheduleFromYunXi ? 'gray' : '508cee' }}
              onClick={store.delModal(id)}
            >
              删除
            </a>
          </span>
        </Tooltip>
      )
    }
  }
]
